import "./App.css";
import { Routes, Route } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./Constants/theme";
import SignIn from "./components/signIn";
import SignUp from "./components/signUp";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./components/Home.js";
import PasswordReset from "./components/ResetPassword.js";
import Gallery from "./components/Gallery.js";
import Productions from "./components/Productions.js";
import Bio from "./components/Bio.js";
import Testimonials from "./components/Testimonials.js";
import Contact from "./components/Contact.js";
import { useState } from "react";
import LoadingAnimation from "./components/LoadingAnimation/LoadingAnimation.js";
import News from "./components/News.js";

function App() {
  const [loading, setLoading] = useState(true);
  return (
    <ThemeProvider theme={theme}>
      {loading && <LoadingAnimation setLoading={setLoading} />}
      <CssBaseline />
      {true && (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/resetpassword" element={<PasswordReset />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/productions" element={<Productions />} />
          {/* <Route path="/bio" element={<Bio />} /> */}
          <Route path="/testimonials" element={<Testimonials />} />
          {/* <Route path="/news" element={<News />} /> */}
          <Route path="/contact" element={<Contact />} />
        </Routes>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 999999999999,
        }}
      />
    </ThemeProvider>
  );
}

export default App;
